import { createPortal } from "react-dom";
import Div from "../Div";
import Form from "../Form";
import FormButton from "../FormButton";
import { useEffect, useState } from "react";
import { getRenewalResellerCustomer, sendResellerNotification } from "../../http/renewalHttp/RenewalHttp";
import AddCommentModal from "./AddCommentModal";

export default function RenewalResellerNotificationModal({ notify, handleClicked, ...props }) {

    const [customers, setCustomers] = useState([]);
    const [contacts, setContacts] = useState([]); // Array to store additional email & phone inputs
    const [addComment, setAddComment] = useState(false)

    useEffect(() => {
        async function fetchCustomerData() {
            console.log(notify)
            const customerResponse = await getRenewalResellerCustomer(notify.month, notify.reseller_email,
                 notify.tag, notify.assigned_to);
            setCustomers(customerResponse.domain);
            // Initialize contacts based on existing customer data (if available)
            const initialContacts = [];
            customerResponse.domain?.forEach((customer) => {
                initialContacts.push({
                    email: customer.email || "", // Use existing email or empty string
                    phone: customer.phone || ""  //Use existing phone or empty string
                })
            })
            setContacts(initialContacts);
        }
        fetchCustomerData();
    }, [notify]);

    function handleClose() {
        handleClicked(false);
    }

    // function handleInputChange(index, field, event) {
    //     const updatedContacts = [...contacts];
    //     updatedContacts[index][field] = event.target.value;
    //     setContacts(updatedContacts);
    // }

    // function handleAddContact() {
    //     setContacts([...contacts, { email: "", phone: "" }]);
    // }

    // function handleRemoveContact(index) {
    //     setContacts(contacts.filter((_, i) => i !== index));
    // }

    function handleAddComment(renewal_id) {
        
        setAddComment(renewal_id)
    }

    function formatDate(dateString) {
        if (!dateString) return "";
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    async function handleSendNotification(event) {
        event.preventDefault();
        let subscriptionIds = customers.map(customer => customer.subscriptionId).join(",");
        let renewalDates = customers.map(customer => formatDate(customer.shivaami_renewal_date)).join(",");
        const emailAddresses = contacts.map(c => c.email).filter(email => email);
        const phoneNumbers = contacts.map(c => c.phone).filter(phone => phone);

        await sendResellerNotification(subscriptionIds, renewalDates, notify.reseller_company, emailAddresses, phoneNumbers);
        // window.location.reload();
        handleClicked(false)
    }

    return (
        <>
            {createPortal(
                <Div className="modal-backdrop">
                    {addComment ? <AddCommentModal type='renewal' comments={addComment} show={true.toString()} open handleClicked={setAddComment} /> : null}
                    <dialog {...props} style={{ zIndex: '1', maxWidth: '100%' , overflow: 'auto'}}>
                        <Div className='modal-content'>

                        <Div className="form-group">
                            Send Notification to {notify.reseller_email}
                        </Div>

                        <Form onSubmit={handleSendNotification}>
                            {customers.length > 0 ?
                                <>
                                <Div className="">
                                    
                                    <table className="table table-responsive" border="1">
                                        <thead>
                                            <tr>
                                                <th>Customer Domain</th>
                                                <th>Plan</th>
                                                <th>Status</th>
                                                <th>License</th>
                                                <th>Users</th>
                                                <th>Sku Id</th>
                                                <th className="sortable-header"
                                                // onClick={() => handleSort("renewal_date")}
                                                >Renewal Date
                                                    {/* {sortColumn === "renewal_date" ? (
                                                                    sortOrder === "asc" ? (
                                                                        <FaSortUp className="sort-icon" />
                                                                    ) : (
                                                                        <FaSortDown className="sort-icon" />
                                                                    )
                                                                ) : (
                                                                    <FaSort className="sort-icon" /> // Default sort icon
                                                                )} */}
                                                </th>
                                                <th>Google Renewal Date</th>
                                                <th>Price</th>


                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {customers.map((customer) => (
                                                <tr key={customer.renewal_id}>
                                                    <td>
                                                        {customer.customerDomain}
                                                    </td>
                                                    <td>{customer.plan}</td>
                                                    <td>{customer.status}</td>
                                                    <td>{customer.maxSeats}</td>
                                                    <td>{customer.usedSeats}</td>
                                                    <td>{customer.skuName}</td>
                                                    <td>{formatDate(customer.shivaami_renewal_date)}</td>

                                                    <td>{formatDate(customer.Google_renewal_date)}</td>
                                                    <td>{customer.price}</td>
                                                    <td>
                                                        <FormButton
                                                            type='button'
                                                            className="btn btn-primary submit-btn btn-block"
                                                            onClick={() => handleAddComment(customer.renewal_id)}
                                                        >Add Comments</FormButton>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>


                                    </Div>

                                    {/* {contacts.map((contact, index) => (
                                        <Div className="form-group" key={index} style={{ display: "flex", flexDirection: "row" }}>
                                            <div style={{ flexGrow: 1 }}>
                                                <label>Email</label>
                                                <Input value={contact.email} type="text" onChange={(event) => handleInputChange(index, "email", event)} className="form-control" />
                                            </div>
                                            <div style={{ flexGrow: 1 }}>
                                                <label>Phone</label>
                                                <Input value={contact.phone} type="text" onChange={(event) => handleInputChange(index, "phone", event)} className="form-control" />
                                            </div>
                                            <FormButton type="button" onClick={() => handleRemoveContact(index)} className="btn btn-danger" style={{ marginTop: "30px", marginLeft: "10px" }}>
                                                Remove
                                            </FormButton>
                                        </Div>
                                    ))} */}

                                    {/* <Div className="form-group">
                                        <FormButton type="button" onClick={handleAddContact} className="btn btn-secondary">Add Contact</FormButton>
                                    </Div> */}

                                    <Div className="form-group">
                                        <Div className='row'>
                                            <Div className='col-sm-4'>
                                                <FormButton type='submit' style={{ margin: '2px' }} className="btn btn-primary submit-btn btn-block">Send Notification</FormButton>
                                            </Div>

                                            <Div className='col-sm-4'>
                                                <FormButton type='button' style={{ margin: '2px' }} onClick={handleClose} className="btn btn-primary submit-btn btn-block">Close</FormButton>
                                            </Div>
                                        </Div>
                                    </Div>
                                </> : 'No Data Present'}
                        </Form>
                        
                        </Div>
                    </dialog>

                </Div>
                , document.getElementById('modal'))

            }

        </>
    )
}